<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="section" v-on:click="goTo('/inventory/action/list')">Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Nueva Actuación</a>
    </div>
    <h1 class="ui header"><i class="icon file alternate outline"></i>
      <div class="content">Nueva Actuación</div>
    </h1>
    <button class="ui basic button rightButton" v-on:click="goTo('/inventory/action/list')">
      <i class="long arrow alternate left icon"></i>Atras
    </button>
    <div class="ui stackable one column divided grid container">
      <div class="row">
        <div class="column">
          <form class="ui form">
            <h4 class="ui dividing header">Datos Actuación</h4>

            <div class="two fields">
              <div class="field">
                <label>Fecha Actuación</label>
                <input type="datetime-local" v-model="newAction.action_date" placeholder="Fecha actuacion*"
                  id="idActionDate">
              </div>
              <div class="field">
                <label>Máquina *</label>
                <sui-dropdown fluid search selection :options="apmsOptions" v-model="newAction.apm"
                  placeholder="Máquinas" required id="idApm" />
              </div>
            </div>

            <div class="field" v-show="newAction.action_type_key !== 'desinstalacion'">
              <label>Tipo Actuación *</label>
              <sui-dropdown fluid search selection required="required" :options="typesOptions"
                v-model="newAction.action_type" placeholder="Tipo de actuación*" id="idActionType" />
            </div>

            <div class="two fields" v-if="newAction.action_type_key === 'desinstalacion'">
              <div class="field">
                <label>Tipo Actuación *</label>
                <sui-dropdown fluid search selection required="required" :options="typesOptions"
                  v-model="newAction.action_type" placeholder="Tipo de actuación*" id="idActionType" />
              </div>
              <div class="field" id="idCheckProvisional">
                <div class="ui toggle checkbox">
                  <input type="checkbox" name="public" v-model="newAction.provisional">
                  <label>Provisional</label>
                </div>
              </div>
            </div>

            <div
              v-if="(storesOptions.length > 0 && (stockNameOptions.length > 0 || columnNamesOptions.length > 0 || newAction.stocks.length > 0))"
              class="field" id="idStocks">
              <selectStock :theIsNew="isNew" :theBlockStock="blockStock" :theFlujoStock="newAction.flujo_stock"
                :theActionTypeKey="newAction.action_type_key" :theStores="storesOptions"
                :theStockNames="stockNameOptions" :theColumnNames="columnNamesOptions"
                :theStockSelected="newAction.stocks" :theLetAddItem="letAddItem" :allowEdit="true"
                v-model="newAction.stocks" @stockSelected="stockSelected"></selectStock>
            </div>

            <div class="two fields">
              <div class="field">
                <label>Cliente *</label>
                <sui-dropdown fluid search selection :options="clientsOptions" v-model="newAction.client"
                  placeholder="Cliente" required id="idClient" />
              </div>
              <div class="field">
                <label>Proveedor Actuaciones *</label>
                <sui-dropdown fluid search selection :options="providersOptions" v-model="newAction.action_provider_id"
                  placeholder="Proveedor" required id="idProvider" />
              </div>
            </div>

            <div class="two fields">
              <div class="field">
                <label>Imputación</label>
                <sui-dropdown fluid search selection :options="imputationsOptions" v-model="newAction.imputation_id"
                  placeholder="Imputación" />
              </div>
              <div class="field">
                <label>Nº Tickets</label>
                <input type="text" v-model="newAction.n_ticket" placeholder="Nº Tickets">
              </div>
            </div>

            <div class="ui segment">
              <div class="field">
                <label>Envío Columnas/Piezas</label>
                <!-- <selectOption id="idSendStock" :theDefaultOption="'no'" :theFirstOption="firstOption" :theSecondOption="secondOption" :theDisabledOption="disabledOption" :theIdentifier="'ss'" v-model="newAction.send_stock" @selectOption_ss="selectOption_ss"></selectOption> -->
                <selectOption :theFirstOption="firstOption" :theSecondOption="secondOption" :theDisabledOption="false"
                  v-model="newAction.send_stock"></selectOption>
              </div>

              <div class="two fields" v-if="newAction.send_stock">
                <div class="field">
                  <label>Fecha Envío</label>
                  <input type="datetime-local" id="idSendDate" v-model="newAction.send_date" placeholder="Fecha envío">
                </div>
                <div class="field">
                  <label>Transportista</label>
                  <sui-dropdown fluid search selection id="idCourier" :options="couriersOptions"
                    v-model="newAction.courier" placeholder="Transportista" />
                </div>
              </div>

              <div class="two fields" v-if="newAction.send_stock">
                <div class="field">
                  <label>Nº Palets</label>
                  <input type="number" id="idPalets" min="0" v-model="newAction.n_palets" placeholder="Nº Palets"
                    oninput="this.value = (this.value.replace(/[^0-9]/g, 0).replace('/(\..*?)\..*/g', 0)) ? this.value : 0;">
                </div>
                <div class="field">
                  <label>Aduanas</label>
                  <input type="text" v-model="newAction.customs" placeholder="Aduanas">
                </div>
              </div>
            </div>

            <div class="field">
              <label>Descripción</label>
              <textarea rows="4" maxlength="2000" v-model="newAction.observations"></textarea>
            </div>

            <div class="field">
              <label>* Campos Obligatorios</label>
            </div>

            <div class="field" id="idBtns">
              <button id="idAniadir" class="ui button" type="button" v-on:click="createNewAction">Crear
                Actuación</button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
import selectOption from '@/components/selectOption.vue'
import selectStock from '@/components/selectStock.vue'

export default {
  name: 'actionAdd',
  data() {
    return {
      newAction: {
        action_date: null,
        action_type: null,
        action_type_key: null,
        flujo_stock: null,
        apm: null,
        imputation: null,
        n_ticket: null,
        client: null,
        provider: null,
        send_stock: false,
        stocks: [],
        customs: null,
        observations: null,
        send_date: null,
        courier: null,
        n_palets: null,
        store: null,
        provisional: false
      },
      firstOption: "Si",
      secondOption: "No",
      letAddItem: false,
      clientsOptions: [],
      apmsOptions: [],
      imputationsOptions: [],
      storesOptions: [],
      typesOptions: [],
      providersOptions: [],
      couriersOptions: [],
      stockNameOptions: [],
      stockIdentifiersOptions: [],
      columnNamesOptions: [],
      columnIdentifiersOptions: [],
      changeComboStocks: false,
      apt_id: null,
      blockStock: false,
      isNew: true
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin') {
      this.getDataFilters()
    } else {
      this.$router.replace('/inventory')
    }
  },
  mounted() {
    const tzoffset = (new Date()).getTimezoneOffset() * 60000;
    this.newAction.action_date = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -5);
  },
  beforeUpdate() {
    if (this.changeComboStocks) {
      if (this.newAction.action_type) {
        let flujoStock = this.typesOptions.find((e) => e.value == this.newAction.action_type).flujoStock
        if (flujoStock === 'E') {
          this.letAddItem = true
        } else {
          this.letAddItem = false
        }
      }
      this.changeComboStocks = false
    }
  },
  watch: {
    'newAction.apm': function (new_apm, old_apm) {
      if (new_apm) {
        this.apt_id = new_apm
        if (new_apm && this.newAction.flujo_stock) {
          this.initializeParams()
          if (this.newAction.flujo_stock !== 'X') {
            this.getStocksByApt(new_apm, this.newAction.flujo_stock)
          }
        }
      }
    },
    'newAction.action_type': function (new_type, old_type) {
      if (new_type) {
        this.newAction.action_type = new_type
        let type = this.typesOptions.find((e) => e.value == new_type)
        this.newAction.action_type_key = type.key
        this.newAction.flujo_stock = type.flujoStock
        if (this.apt_id && this.newAction.flujo_stock) {
          this.initializeParams()
          if (this.newAction.flujo_stock !== 'X') {
            this.getStocksByApt(this.apt_id, this.newAction.flujo_stock)
          }
        }
      }
    },
  },
  methods: {
    initializeParams() {
      this.columnNamesOptions = [];
      this.columnIdentifiersOptions = [];
      this.stockNameOptions = [];
      this.stockIdentifiersOptions = [];
      this.newAction.stocks = [];
      this.changeComboStocks = true;
    },
    initializeStyles() {
      let borderNone = "border-color: none !important"
      document.getElementById("idActionType").style = borderNone
      document.getElementById("idApm").style = borderNone
      document.getElementById("idClient").style = borderNone
      document.getElementById("idProvider").style = borderNone
      document.getElementById("idActionDate").style = borderNone

      if (this.newAction.flujo_stock !== 'X') {
        if (this.newAction.apm && this.newAction.action_type) {
          document.getElementById("idStocks").style = borderNone
        }
      }

      if (this.newAction.send_stock) {
        document.getElementById("idSendDate").style = borderNone
        document.getElementById("idCourier").style = borderNone
      }
    },
    validateForm(data) {
      this.initializeStyles();
      let next = true;

      if (
        (data.send_stock && data.apm && data.stocks.length == 0)
        || (data.send_stock && (!data.send_date || !data.courier))
        || !data.apm
        || !data.client
        || !data.action_provider_id) {
        next = false
      }

      let borderError = "border: 1px solid red !important"

      if (!data.action_type) {
        document.getElementById("idActionType").style = borderError
      }
      if (!data.apm) {
        document.getElementById("idApm").style = borderError
      }
      if (!data.client) {
        document.getElementById("idClient").style = borderError
      }
      if (!data.action_provider_id) {
        document.getElementById("idProvider").style = borderError
      }
      if (data.send_stock) {
        if (!data.send_date) {
          document.getElementById("idSendDate").style = borderError
        }
        if (!data.courier) {
          document.getElementById("idCourier").style = borderError
        }
      }
      if (this.newAction.flujo_stock === 'E') {
        if (data.apm && data.action_type && data.stocks.length == 0) {
          document.getElementById("idStocks").style = borderError
        }

        data.stocks.forEach(element => {
          if (element.store_id == 0) {
            next = false
            document.getElementById("idStocks").style = borderError
          }
        });
      }

      if (!next) {
        this.$swal.fire({
          type: 'warning',
          title: 'Campos obligatorios',
          text: 'Falta uno o varios campos obligatorio. '
        })
      }

      return next
    },
    async createNewAction() {
      if (this.validateForm(this.newAction)) {
        let x = document.getElementById("idAniadir");
        x.classList.add("loading");
        x.disabled = true;

        hapiickApi().post('/v1/actions/add', {
          admin_id: JSON.parse(localStorage.admin).id,
          newAction: this.newAction
        })
          .then(request => {
            if (request.data.status === 'OK') {
              this.$swal({
                type: 'success',
                title: 'Se ha creado la actuación correctamente',
                showConfirmButton: false,
                timer: 2500
              })
              this.redirect(JSON.parse(JSON.stringify(request.data.action)));
            } else if (request.data.status === 'last_action_opened') {
              let ruta = '/#/inventory/action/info/' + request.data.id
              this.$swal({
                type: 'warning',
                title: 'Acción requerida',
                text: request.data.message,
                html: request.data.message + " </br> " +
                  '<a href="' + ruta + '" target="_blank">Ir a la actuación</a>',
              })
              x.classList.remove("loading");
              x.disabled = false;
            } else {
              this.$swal({
                type: 'warning',
                title: 'No se ha podido crear la actuación',
                text: request.data.message
              })

              x.classList.remove("loading");
              x.disabled = false;
            }
          })
          .catch((request) => {
            if (error.request.status == 500) {
              request.$swal({
                type: 'error',
                title: 'No se ha podido crear la actuación',
                text: request.request.statusText
              })

              x.classList.remove("loading");
              x.disabled = false;
            } else {
              console.log('error creating action apt: ' + request)
            }
          })
      }
    },
    stockSelected(options) {
      this.newAction.stocks = options
    },
    selectOption_ss(option) {
      this.newAction.send_stock = option
    },
    async getStocksByApt(apt_id, flujo_stock) {
      await hapiickApi().post('/v1/stocks/get-by-apt', {
        admin_id: JSON.parse(localStorage.admin).id,
        apt_id: apt_id,
        flujo_stock: flujo_stock
      })
        .then(response => {
          const stocks_orig = JSON.parse(JSON.stringify(response.data.stocks));
          if (stocks_orig.length > 0) {
            if (this.newAction.action_type) {
              this.fillStocksOptions(stocks_orig)
            }
          } else {
            this.stockNameOptions.push({
              'text': 'No hay repuestos para el modelo de esta máquina',
            })
            this.columnNamesOptions.push({
              'text': 'No hay columnas para el modelo de esta máquina',
            })
          }
        })
        .catch((error) => {
          console.log(`Error getStocksByApt: ${error}`)
        })
    },
    getDataFilters() {
      hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        HapiickClient: true,
        Apt: true,
        Imputation: true,
        ActionProvider: true,
        ActionType: true,
        ActionCourier: true,
        Store: true
      })
        .then(request => {
          this.fillClientsOptions(JSON.parse(JSON.stringify(request.data.data.clients)));
          this.fillApmsOptions(JSON.parse(JSON.stringify(request.data.data.apms)));
          this.fillImputationsOptions(JSON.parse(JSON.stringify(request.data.data.imputations)));
          this.fillProvidersOptions(JSON.parse(JSON.stringify(request.data.data.providers)));
          this.fillTypesOptions(JSON.parse(JSON.stringify(request.data.data.types)));
          this.fillCouriersOptions(JSON.parse(JSON.stringify(request.data.data.couriers)));
          this.fillStoresOptions(JSON.parse(JSON.stringify(request.data.data.stores)));
        })
        .catch(() => console.log('error getting combo informations'))
    },
    fillStocksOptions(stocks) {
      this.stockNameOptions = []
      this.stockIdentifiersOptions = []
      this.columnNamesOptions = []
      this.columnIdentifiersOptions = []
      this.newAction.stocks = []
      let store_name = ''

      for (let i = 0; i < stocks.length; i++) {
        const comboOption = (this.newAction.action_type_key === 'desinstalacion') ? this.newAction.stocks : (stocks[i].stock_type === 'R') ? this.stockNameOptions : this.columnNamesOptions;

        for (let j = 0; j < stocks[i].StockProduct.length; j++) {
          if (this.newAction.flujo_stock !== 'E') {
            store_name = this.storesOptions.find((e) => (e.value == stocks[i].StockProduct[j].store_id)).text
          }

          if (this.newAction.action_type_key !== 'desinstalacion') {
            let exist = undefined
            if (comboOption.length > 0) {
              exist = comboOption.find((e) => (e.id == stocks[i].id && e.store_id == stocks[i].StockProduct[j].store_id))
            }
            if (exist) {
              comboOption.map((a) => {
                if ((a.id == stocks[i].id && a.store_id == stocks[i].StockProduct[j].store_id)) {
                  a.identificadores.push(this.mountIdentifierOption(store_name, stocks[i], stocks[i].StockProduct[j]))
                  a.text = stocks[i].name + ' (' + a.identificadores.length + ')'
                  a.quantity = a.identificadores.length
                }
                return a
              })
            } else {
              let aux = {}
              aux['id'] = stocks[i].id
              aux['value'] = stocks[i].id
              aux['key'] = stocks[i].id
              aux['name'] = stocks[i].name
              aux['stockType'] = stocks[i].stock_type
              aux['nSlots'] = stocks[i].n_slots
              aux['store_id'] = stocks[i].StockProduct[j].store_id
              aux['store_name'] = store_name
              aux['desglose'] = stocks[i].desglose
              aux['identificadores'] = []
              aux['identificadores'].push(this.mountIdentifierOption(store_name, stocks[i], stocks[i].StockProduct[j]))
              aux['quantity'] = stocks[i].StockProduct[j].quantity
              if (stocks[i].desglose) {
                aux['text'] = stocks[i].name + ' (' + aux['identificadores'].length + ')'
              } else {
                aux['text'] = stocks[i].name + ' (' + stocks[i].StockProduct[j].quantity + ')'
              }
              comboOption.push(aux)
            }
          } else {
            comboOption.push(this.mountIdentifierOption(store_name, stocks[i], stocks[i].StockProduct[j]))
          }
        }
      }
    },
    mountIdentifierOption(store_name, stock, identifier) {
      let identificador = {}

      identificador['id'] = identifier.id
      identificador['key'] = identifier.id
      identificador['stock_product_id'] = identifier.id
      identificador['stock_id'] = identifier.stock_id
      identificador['store_id'] = identifier.store_id
      identificador['name'] = stock.name
      identificador['stockType'] = stock.stock_type
      identificador['store_name'] = store_name
      identificador['apt_id'] = identifier.apt_id
      identificador['quantity'] = identifier.quantity
      identificador['nSlots'] = stock.n_slots
      identificador['desglose'] = stock.desglose
      identificador['quantitySelected'] = 1
      identificador['product_identifier'] = identifier.product_identifier
      identificador['product_identifier_prov'] = identifier.product_identifier_prov
      identificador['value'] = identifier.id
      identificador['text'] = (identifier.product_identifier_prov) ? identifier.product_identifier_prov : identifier.product_identifier

      return identificador
    },
    fillTypesOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.typesOptions.push({
          key: data[i].ActionType.key,
          text: data[i].ActionType.name,
          value: data[i].ActionType.id,
          flujoStock: data[i].ActionType.flujo_stock
        })
      }
    },
    fillProvidersOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.providersOptions.push({
          key: data[i].ActionProvider.key,
          text: data[i].ActionProvider.name,
          value: data[i].ActionProvider.id
        })
      }
    },
    fillCouriersOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.couriersOptions.push({
          key: data[i].ActionCourier.key,
          text: data[i].ActionCourier.name,
          value: data[i].ActionCourier.id
        })
      }
    },
    fillClientsOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.clientsOptions.push({
          key: data[i].HapiickClient.key,
          text: data[i].HapiickClient.name,
          value: data[i].HapiickClient.id
        })
      }
    },
    fillApmsOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.apmsOptions.push({
          key: data[i].Apt.id,
          text: data[i].LanguagesApts[0].name,
          value: data[i].Apt.id,
          apt_model_id: data[i].Apt.apt_model_id
        })
      }
    },
    fillImputationsOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.imputationsOptions.push({
          key: data[i].Imputation.key,
          text: data[i].Imputation.name,
          value: data[i].Imputation.id,
        })
      }
    },
    fillStoresOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.storesOptions.push({
          key: data[i].Store.key,
          text: data[i].Store.name,
          value: data[i].Store.id,
        })
      }
    },
    goTo(where) {
      this.$router.push(where)
    },
    redirect(id) {
      let routeData = this.$router.resolve('/inventory/action/info/' + id);
      window.open(routeData.href, '_self');
    },
  },
  components: {
    'selectOption': selectOption,
    'selectStock': selectStock
  }
}
</script>
<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

#idBtns {
  display: flex;
  justify-content: center;
}

#idAniadir {
  background-color: black !important;
  color: white;
  width: 35%;
}

#idCheckProvisional {
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Inventory/actionAdd.vue